import React, { useEffect, useState } from "react";
import "./Footer.css";
import bing from "./images/bing-partner.jpg";
import facebook from "./images/facebook-partner.jpg";
import google from "./images/google-partner.jpg";
import iso from "./images/iso-certification.jpg";
import { Link } from "react-router-dom";
import { IoMailOpen } from "react-icons/io5";
import logo from "../Header/image/justseologo.png";
import axios from "axios";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const scrollingDown = currentScrollPos > prevScrollPos;

      // Show footer when scrolling down, hide when scrolling up
      setIsVisible(scrollingDown);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos]);

  const toggleForm = () => {
    setShowForm(!showForm);
  };

    const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    budget: "",
  });

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://justseo.in/api/sendemail",
        formData
      );
      console.log(response.data);
      setShowSuccess(true);
      setFormData({ name: "", phone: "", email: "", budget: "" });

      // Auto-hide after 3 seconds
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message.");
    }
  };

  return (
    <>
      <footer className="footer">
        <h2 className="footer-header">The Sun Never Sets on Just SEO</h2>
        <div className="footer-locations">
          {/* First row - single column items */}
          {[
            {
              country: "Corporate Office",
              address:
                "B-13, 2nd Floor, Prozone Trade Center, beside Prozone Mall, MIDC Industrial Area, Chilkalthana, Aurangabad,Maharashtra 431003",
              email: "info@justseo.in",
            },
            {
              country: "Bengaluru",
              address:
                "S End C Cross Rd, KSRTC Layout, 3 nd Phase, JP Nagar, Bengaluru,Karnataka 560078",
              email: "digital@justseo.in",
            },
            {
              country: "Hyderabad",
              address:
                "Admin Block, Mariner Bldg The V Plot No. 17, Software Units Layout Madhapur Hyderabad 500081",
              email: "digital@justseo.in",
            },
          ].map((loc) => (
            <div key={loc.country} className="footer-location">
              <div className="footer-location-icon">{loc.icon}</div>
              <div className="footer-location-content">
                <h3>{loc.country}</h3>
                <p>{loc.address}</p>
                <p>
                  <IoMailOpen /> E-Mail: {loc.email}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Second row - three locations in one row */}
        <div className="footer-locations three-column">
          {[
            {
              country: "Chennai",
              address:
                "5 st Floor, Pinnacle Building International Tech Park Chennai (ITPC) Taramani Road Chennai-600113",
              email: "digital@justseo.in",
            },
            {
              country: "New York",
              address: "295 Madison Ave 12th Floor New York City, NY 10017",
              email: "digital@justseo.in",
            },
            {
              country: "Sydney",
              address:
                "680 George Street Level 45, Haymarket Sydney, Australia 2000",
              email: "digital@justseo.in",
            },
          ].map((loc) => (
            <div key={loc.country} className="footer-location">
              <div className="footer-location-icon">{loc.icon}</div>
              <div className="footer-location-content">
                <h3>{loc.country}</h3>
                <p>{loc.address}</p>
                <p>
                  <IoMailOpen /> E-Mail: {loc.email}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="footer-sections">
          <div className="footer-links">
            <div>
              <h5>Our Company</h5>
              <ul>
                <Link to="/about-us">
                  <li>About Us</li>
                </Link>
                <Link to="/contact-us">
                  <li>Contact Us</li>
                </Link>
                <li>Client Reviews</li>
                <li>Video Testimonials</li>
                <li>Privacy Policy</li>
                <li>Latest Blogs</li>
              </ul>
            </div>
            <div>
              <h5>Resources</h5>
              <ul>
                <li>PPC Portfolio</li>
                <li>SEO Portfolios</li>
                <li>Case Studies</li>
              </ul>
            </div>
            <div>
              <h5>Internship</h5>
              <ul>
                <li>Industrial Training Mohali</li>
                <li>Digital Marketing Training</li>
              </ul>
            </div>
            <div>
              <h5>Packages</h5>
              <ul>
                <li>SEO Small Business Packages</li>
                <li>Digital Marketing Packages</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-services">
          <div>
            <h5>Digital Marketing</h5>
            <ul>
              <li>Social Media Marketing</li>
              <li>Paid Marketing</li>
              <li>Amazon PPC Services</li>
              <li>Content Writing</li>
              <li>Web Design Services</li>
              <li>Reputation Management</li>
              <li>Guest Posting Services</li>
              <li>Web Analytics</li>
              <li>Influencer Marketing</li>
              <li>Franchise Digital Marketing</li>
              <li>Shopify Digital Marketing</li>
              <li>Hire Marketer</li>
              <li>Product Marketing Agency</li>
            </ul>
          </div>
          <div>
            <h5>SEO For Industries</h5>
            <ul>
              <li>SEO For Healthcare</li>
              <li>SEO For Doctors</li>
              <li>SEO For NGO</li>
              <li>SEO For Salon</li>
              <li>SEO For Auto Repair</li>
              <li>SEO For Car Dealers</li>
              <li>SEO For Electrician</li>
              <li>SEO For Astrologer</li>
              <li>SEO For Law Firm</li>
              <li>SEO For Restaurants</li>
              <li>SEO For Pharmaceutical</li>
              <li>View More →</li>
            </ul>
          </div>
          <div>
            <h5>Organic SEO</h5>
            <ul>
              <li>Custom SEO Solutions</li>
              <li>Local SEO</li>
              <li>SEO For Small Businesses</li>
              <li>SEO For Shopify</li>
              <li>SEO For Drupal</li>
              <li>SEO For SearchGpt</li>
              <li>Technical SEO Audit</li>
              <li>Contractor SEO Service</li>
              <li>Copywriting Service</li>
              <li>SEO for SaaS</li>
              <li>On Page SEO</li>
              <li>GMB Service</li>
            </ul>
          </div>
          <div>
            <h5>Magento SEO Service</h5>
            <ul>
              <li>International SEO Agency</li>
              <li>National SEO Service</li>
              <li>Google Ads Services</li>
              <li>Faceless Digital Marketing</li>
              <li>Weebly SEO Service</li>
              <li>Virtual Assistant SEO</li>
              <li>SEO Agency For Startups</li>
              <li>Fintech SEO Agency</li>
              <li>Squarespace SEO Agency</li>
              <li>International SEO Agency</li>
              <li>White Label SEO Service</li>
              <li>Webflow SEO Agency</li>
              <li>View More →</li>
            </ul>
          </div>
        </div>

        <div className="footer-logos">
          <img src={google} alt="google partner" />
          <img src={facebook} alt="facebook partner" />
          <img src={bing} alt="bing partner" />
          <img src={iso} alt="iso-certification" />
        </div>

        <div className="footer-bottom">
          ©Just SEO Powered By MK e-Tech Private Limited | All Rights Reserved
        </div>
      </footer>

      {/* Floating Get in Touch Button */}
      <div className={`scroll-footer ${isVisible ? "visible" : "hidden"}`}>
        <div className="footer-content">
          <button className="footer-button" onClick={toggleForm}>
            Get Expert Advice
          </button>
        </div>
      </div>
{showSuccess && (
            <div className="popup-success">
              <p>Awesome! We’ll help you reach the top of Google.</p>
            </div>
          )}
      {/* Popup Form */}
      {showForm && (
        <div className="popup-overlay" onClick={toggleForm}>
          <div
            className="popup-form-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-button" onClick={toggleForm}>
              &times;
            </button>
            <div className="contact-form-wrapper">
              {/* Logo Section */}
              <div className="logo-wrapper">
                <img src={logo} alt="Just SEO Logo" className="company-logo" />
              </div>

              {/* Form Section */}
              <div className="contact-form-box">
                <h2 className="form-heading">SEO That's Out of This World</h2>
                <form className="seo-form" onSubmit={sendEmail}>
                  <div className="seo-form-group">
                    <input
                      type="text"
                      className="seo-text-input"
                      name="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="seo-form-group">
                    <input
                      type="email"
                      className="seo-email-input"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="seo-form-group">
                    <input
                      type="tel"
                      className="seo-tel-input"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={(e) =>
                        setFormData({ ...formData, phone: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="seo-form-group">
                    <select
                      className="seo-budget-select"
                      name="budget"
                      value={formData.budget}
                      onChange={(e) =>
                        setFormData({ ...formData, budget: e.target.value })
                      }
                      required
                    >
                      <option value="" disabled>
                        Monthly Budget
                      </option>
                      <option value="1000-2500">₹1,000 - ₹2,500</option>
                      <option value="2500-5000">₹2,500 - ₹5,000</option>
                      <option value="5000-10000">₹5,000 - ₹10,000</option>
                      <option value="10000-25000">₹10,000 - ₹25,000</option>
                      <option value="25000+">₹25,000+</option>
                    </select>
                  </div>
                  <button className="seo-submit-btn" type="submit">
                    Send
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
